import { render, staticRenderFns } from "./filter-selector.component.vue?vue&type=template&id=52a29f0a&scoped=true"
import script from "./filter-selector.component.vue?vue&type=script&lang=js"
export * from "./filter-selector.component.vue?vue&type=script&lang=js"
import style0 from "./filter-selector.component.vue?vue&type=style&index=0&id=52a29f0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a29f0a",
  null
  
)

export default component.exports